"use client";

import { Moon, Sun } from "lucide-react";
import { LOCALES } from "@/lib/i18n";
import { usePrefs } from "./prefs-provider";

export function PrefsControls({ compact = false }: { compact?: boolean }) {
  const { locale, theme, setLocale, toggleTheme, t } = usePrefs();

  return (
    <div className="flex items-center gap-1.5">
      <div
        role="group"
        aria-label={t.nav.language}
        className="flex overflow-hidden rounded-lg border border-[var(--line)] bg-[var(--foam)]"
      >
        {LOCALES.map((l) => {
          const active = locale === l.id;
          return (
            <button
              key={l.id}
              type="button"
              onClick={() => setLocale(l.id)}
              className={`inline-flex items-center gap-1 px-2 py-1.5 text-xs font-bold ${
                active ? "bg-[var(--teal)] text-white" : "text-[var(--ink-soft)] hover:text-[var(--ink)]"
              }`}
              aria-pressed={active}
            >
              <span aria-hidden>{l.flag}</span>
              <span>{l.abbr}</span>
            </button>
          );
        })}
      </div>
      <button
        type="button"
        onClick={toggleTheme}
        className="inline-flex h-8 w-8 items-center justify-center rounded-lg border border-[var(--line)] bg-[var(--foam)] text-[var(--ink)] hover:border-[var(--teal)]"
        title={theme === "dark" ? t.nav.themeLight : t.nav.themeDark}
        aria-label={theme === "dark" ? t.nav.themeLight : t.nav.themeDark}
      >
        {theme === "dark" ? <Sun className={compact ? "h-4 w-4" : "h-4 w-4"} /> : <Moon className="h-4 w-4" />}
      </button>
    </div>
  );
}
